import { cv } from "@suse-o11y/class-variance";
import React from "react";

import type { BorgSeverity } from "../models/borg-types";

const severityVariants = cv("mb-2 inline-block rounded-full px-2 py-0.5 font-medium text-xs capitalize", {
	variants: {
		severity: {
			info: "bg-primary-100 text-primary-700",
			low: "bg-grey-100 text-grey-600",
			medium: "bg-yellow-100 text-yellow-800",
			high: "bg-orange-100 text-orange-700",
			critical: "bg-red-100 text-red-700",
		},
	},
	defaultVariants: { severity: "info" },
});

export const SeverityBadge: React.FC<{ severity: BorgSeverity }> = ({ severity }) => (
	<span className={severityVariants({ className: undefined, severity })}>{severity}</span>
);
